$(".review-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(document).ready(function () {
      // Initially open the first FAQ and update the image
      var $firstFaq = $('.tab-content').first();
      $firstFaq.find('.faq-content').show();
      $firstFaq.addClass('active');

      // Fetch the initial image src and update the main image
      var initialImageSrc = $firstFaq.find('img').attr('src');
      $('.image-part .show-desk img').attr('src', initialImageSrc);

      // Add click event to FAQ titles
      $('.faq-title').on('click', function () {
        var $currentTab = $(this).closest('.tab-content');

        // Close all other FAQ contents
        $('.tab-content').not($currentTab).removeClass('active').find('.faq-content').slideUp();

        // Toggle the clicked FAQ
        $currentTab.toggleClass('active');
        $currentTab.find('.faq-content').slideToggle();

        // Fetch the image src from the active tab and update the main image
        if ($currentTab.hasClass('active')) {
          var imageSrc = $currentTab.find('img').attr('src');
          $('.image-part .show-desk img').attr('src', imageSrc);
        } else {
          // Optionally clear the image src if no tab is active
          $('.image-part .show-desk img').attr('src', '');
        }
      });
    });